import React, { createContext, useReducer, useContext } from 'react';
import { rootReducer, GlobalState, ActionType, initialState } from '../store';

interface AppContextType {
  state: GlobalState;
  dispatch(action: ActionType): void;
}
const AppContext = createContext<AppContextType>({
  state: initialState,
  dispatch: () => undefined,
});

interface AppProviderType {
  children: React.ReactNode;
}

export const AppProvider: React.FC<AppProviderType> = ({ children }) => {
  const [state, dispatch] = useReducer<React.Reducer<GlobalState, ActionType>>(
    rootReducer as unknown as React.Reducer<GlobalState, ActionType>,
    initialState,
  );

  const value = { state, dispatch };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useStore = () => {
  const { state, dispatch } = useContext<AppContextType>(AppContext);
  return { state, dispatch };
};

export const useStoreUser = () => {
  const { state } = useContext<AppContextType>(AppContext);
  return { user: state?.user?.data };
};

export const useStoreTutorial = () => {
  const { state } = useContext<AppContextType>(AppContext);
  return { tutorial: state?.tutorial };
}